/** Canonical empty-list illustration and copy for React and plain DOM hosts.
 * Text is escaped here; callers never supply HTML. */
export function listEmptyStateMarkup(title, hint) {
    const text = (value) => value.replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
    return '<svg class="oq-list-empty__icon" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/><path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z"/></svg>' +
        '<p class="oq-list-empty__title">' + text(title) + '</p>' +
        (hint ? '<p class="oq-list-empty__hint">' + text(hint) + '</p>' : '');
}
//# sourceMappingURL=listEmptyStateMarkup.js.map